import {
    Button,
    styled,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    CircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { path } from "../../../routes";

const AddOrg_modal = (props) => {
    const VisuallyHiddenInput = styled("input")({
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        bottom: 0,
        left: 0,
        whiteSpace: "nowrap",
        width: 1,
    });

    const [file, setFile] = useState(null);
    const [name, setName] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [loading, setLoading] = useState(false);

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImageUrl(e.target.result);
            };
            reader.readAsDataURL(selectedFile);
        } else {
            setImageUrl("");
        }
    };

    const delete_file_handler = () => {
        setFile(null);
        setImageUrl("");
    };

    const close_handler = () => {
        props.close();
    };

    const handleSubmit = async () => {
        if (!file || !name.trim()) {
            alert("Please fill in all required fields and upload an image");
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("description", name);

            await axios.post(`${path}/addneworganization`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            alert("File uploaded successfully");
            props.close();
        } catch (error) {
            console.error("Error uploading file:", error);
            alert("Error uploading file");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={true}
            onClose={close_handler}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: { xs: 0, sm: "12px" },
                    maxHeight: { xs: "100vh", sm: "90vh" },
                    margin: { xs: 0, sm: "32px" },
                    width: { xs: "100%", sm: "auto" },
                },
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: { xs: "18px", sm: "20px" },
                    fontWeight: 600,
                    pb: 1.5,
                    borderBottom: "1px solid #e0e0e0",
                }}
            >
                Add Organization
            </DialogTitle>

            <DialogContent
                sx={{
                    pt: 3,
                    pb: 3,
                    px: { xs: 2, sm: 3 },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                        mb: 2,
                        paddingTop: 2,

                    }}
                >
                    {file === null ? (
                        <Button
                            color="primary"
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<CloudUploadIcon />}
                            sx={{
                                width: { xs: "100%", sm: "auto" },
                                minWidth: { xs: "100%", sm: 200 },
                                height: { xs: "48px", sm: "auto" },
                                fontSize: "15px",
                                fontWeight: 500,
                            }}
                        >
                            Upload logo
                            <VisuallyHiddenInput
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </Button>
                    ) : (
                        <Box
                            sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    maxWidth: { xs: "100%", sm: "250px" },
                                    maxHeight: { xs: "150px", sm: "200px" },
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    padding: 1,
                                    backgroundColor: "#f8f9fa",
                                    width: "100%",
                                }}
                            >
                                <img
                                    src={imageUrl}
                                    alt="Preview"
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                        borderRadius: "4px",
                                    }}
                                />
                            </Box>
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={delete_file_handler}
                                startIcon={<DeleteIcon />}
                                sx={{
                                    width: { xs: "100%", sm: "auto" },
                                    minWidth: { xs: "100%", sm: 200 },
                                }}
                            >
                                Remove image
                            </Button>
                        </Box>
                    )}
                </Box>

                <TextField
                    sx={{ width: "100%" }}
                    id="name"
                    label="Organization name"
                    variant="outlined"
                    value={name}
                    onChange={handleNameChange}
                    fullWidth
                    required
                />
            </DialogContent>

            <DialogActions
                sx={{
                    px: { xs: 2, sm: 3 },
                    pb: { xs: 2, sm: 2.5 },
                    pt: 2,
                    borderTop: "1px solid #e0e0e0",
                    gap: { xs: 1, sm: 1.5 },
                    flexDirection: { xs: "column", sm: "row" },
                }}
            >
                <Button
                    onClick={close_handler}
                    disabled={loading}
                    variant="outlined"
                    sx={{
                        width: { xs: "100%", sm: "auto" },
                        minWidth: { xs: "100%", sm: 120 },
                        height: { xs: "48px", sm: "auto" },
                        order: { xs: 2, sm: 1 },
                    }}
                >
                    Cancel
                </Button>
                <Button
                    disabled={!file || !name.trim() || loading}
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                        width: { xs: "100%", sm: "auto" },
                        minWidth: { xs: "100%", sm: 120 },
                        height: { xs: "48px", sm: "auto" },
                        fontWeight: 600,
                        order: { xs: 1, sm: 2 },
                        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.3)",
                        "&:hover": {
                            boxShadow: "0 6px 16px rgba(25, 118, 210, 0.4)",
                        },
                        "&:disabled": {
                            backgroundColor: "#e0e0e0",
                            color: "#9e9e9e",
                        },
                    }}
                >
                    {loading ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <CircularProgress size={20} color="inherit" />
                            <span>Saving...</span>
                        </Box>
                    ) : (
                        "Save"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddOrg_modal;
